import React, { useEffect, useState } from "react";
import styled from "styled-components";
import InputBar from "../../../components/TrainingStatus/InputBar";
import FilterListIcon from "@material-ui/icons/FilterList";
import FilterButton from "../../../components/Common/FilterButton";
import Badge from "@material-ui/core/Badge";
import RiderPayoutsList from "../../../components/DriverSupport/RiderPayoutsList";
import RiderPayoutsModal from "../../../components/DriverSupport/RiderPayoutsModal";
import * as DriverSupportActions from "../../../store/actions/DriverSupport";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { FlexContainer, Heading } from "../../../constants/assets/containers";

const RiderPayouts = ({
  getRiderPayouts,
  resetState,
  riderPayouts,
  activeFilters,
}) => {
  const [activeId, setActiveId] = useState("");
  const [modalState, setModalState] = useState(false);
  const filterFields = ["driver_id", "start_date", "end_date", "payout_type"];

  const handleClick = (type, id) => {
    setActiveId(id);
    setModalState(type);
  };

  const handleClose = () => {
    setModalState("");
  };

  return (
    <RiderPayoutViewContainer className="riderPayoutContainer">
      <FlexContainer className="mb-20">
        <Heading>Rider Payouts History</Heading>
        <FilterButton
          activeFilters={activeFilters}
          handleClick={() => handleClick("Filter", null)}
          data-testid="riderPayoutFilterButton"
        />
      </FlexContainer>
      <RiderPayoutsList list={riderPayouts} filters={activeFilters} />
      {modalState && (
        <RiderPayoutsModal
          modalState={modalState}
          handleClose={handleClose}
          filterFields={filterFields}
        />
      )}
    </RiderPayoutViewContainer>
  );
};

const RiderPayoutViewContainer = styled.section`
  & div > div:nth-child(2) {
    margin-bottom: unset;
  }
`;

function mapStateToProps(state) {
  const { DriverSupport } = state;
  return {
    riderPayouts: DriverSupport.riderPayouts,
    activeFilters: DriverSupport.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getRiderPayouts: bindActionCreators(
      DriverSupportActions.getRiderPayouts,
      dispatch
    ),
    resetState: bindActionCreators(DriverSupportActions.resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RiderPayouts);
